export default function Testimonials() {
  const testimonials = [
    {
      quote: "LCA Group made our lead inspection process seamless. Their team was professional, thorough, and delivered reports quickly. We've used them for over 200 units and couldn't be happier.",
      author: 'Michael Rodriguez',
      role: 'Property Manager, Urban Housing Partners',
      avatar: 'MR',
    },
    {
      quote: "Working with LCA on our housing authority compliance program has been excellent. They understand HUD requirements inside and out and communicate clearly with our team.",
      author: 'Sarah Chen',
      role: 'Director of Operations, County Housing Authority',
      avatar: 'SC',
    },
    {
      quote: "As a developer, I need environmental consultants I can trust. LCA provides accurate assessments, practical guidance, and helps keep our renovation projects on schedule.",
      author: 'James Patterson',
      role: 'Principal, Patterson Development Group',
      avatar: 'JP',
    },
  ];

  return (
    <section id="testimonials" className="py-12 sm:py-16 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-black mb-3 sm:mb-4">What Our Clients Say</h2>
          <p className="text-sm sm:text-base text-gray-600 max-w-2xl mx-auto px-4">
            Trusted by property managers, housing authorities, and developers nationwide.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 sm:p-8 hover:shadow-lg transition-shadow">
              <div className="flex items-center mb-3 sm:mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#f59e0b] text-base sm:text-lg"></i>
                ))}
              </div>
              <p className="text-sm text-gray-600 mb-5 sm:mb-6 leading-relaxed italic">"{testimonial.quote}"</p>
              <div className="flex items-center">
                <div className="flex items-center justify-center w-10 h-10 sm:w-12 sm:h-12 bg-black text-white rounded-full mr-3 sm:mr-4 font-bold text-sm sm:text-base flex-shrink-0">
                  {testimonial.avatar}
                </div>
                <div>
                  <div className="font-bold text-black text-sm">{testimonial.author}</div>
                  <div className="text-xs text-gray-500">{testimonial.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
